import { request } from "@/api/client";

export type { EventSettlement, EventSettlementFilters, EventSettlementSummary } from "@/api/events/settlement";
export { fetchEventSettlement as getEventSettlement, rollupEventSettlement } from "@/api/events/settlement";

export type EventCost = {
  id: string;
  category: string;
  amount: number | string;
  memo?: string | null;
  created_by?: string | null;
};

export type EventAllocation = {
  id: string;
  bucket: string;
  label: string;
  amount: number | string;
  memo?: string | null;
};

export function getEventCosts(eventId: string): Promise<EventCost[]> {
  return request(`/events/${encodeURIComponent(eventId)}/costs`);
}

export function addEventCost(
  eventId: string,
  payload: { category: string; amount: number; memo?: string },
): Promise<EventCost> {
  return request(`/events/${encodeURIComponent(eventId)}/costs`, { method: "POST", body: payload });
}

export function deleteEventCost(eventId: string, costId: string): Promise<void> {
  return request(`/events/${encodeURIComponent(eventId)}/costs/${encodeURIComponent(costId)}`, { method: "DELETE" });
}

export function getEventAllocations(eventId: string): Promise<EventAllocation[]> {
  return request(`/events/${encodeURIComponent(eventId)}/allocations`);
}

export function addEventAllocation(
  eventId: string,
  payload: { bucket: "performance" | "merch" | "cogs" | "expense"; label: string; amount: number; memo?: string },
): Promise<EventAllocation> {
  return request(`/events/${encodeURIComponent(eventId)}/allocations`, { method: "POST", body: payload });
}

export function deleteEventAllocation(eventId: string, allocationId: string): Promise<void> {
  return request(`/events/${encodeURIComponent(eventId)}/allocations/${encodeURIComponent(allocationId)}`, { method: "DELETE" });
}
